import i18n from '@/locales'
export default {
  computed: {
    isBackend () {
      return this.$route.path.includes('/backend-tech-support')
    },
  },
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_450'),
        action: obj => {
          this.$router.push({ path: '/account/checkout', query: { bill_id: obj.id } })
        },
        meta: (obj) => ({
          validate: (obj.status === 'onpay' || obj.status === 'due') && this.$moment(obj.deadline).isAfter(this.$moment()),
        }),
        hidden: (obj) => this.isBackend,
      },
    ]
  },
}
